module.exports = __webpack_public_path__ + "static/media/community.14202a9f.webp";